<template>
	<section class>
		<p class="section-title">
			<svg class="icon" aria-hidden="true">
				<use xlink:href="#icon-iconfilldoor"></use></svg
			>快捷操作
		</p>
		<div slot="reference" class="quick-start">
			<div class="quick-link" v-for="(item, idx) in items" :key="idx">
				<template v-if="subjects.length > 1">
					<el-popover v-if="item.to.name != 'personalCenter'" trigger="hover">
						<template v-for="(subject, index) in subjects">
							<el-button type="primary" size="small" :key="index" @click="quickJump(item, subject)"
								><svg style="margin-right: 4px;" class="icon" aria-hidden="true">
									<use :xlink:href="`#icon-${subject.icon}`"></use></svg
								>{{ subject.name }}</el-button
							>
						</template>
						<div slot="reference" :style="'background-color:' + item.background" class="img">
							<span>{{ item.title }}</span>
						</div>
					</el-popover>
				</template>
				<!-- 只有一门学科时 -->
				<template v-if="subjects.length == 1 && item.to.name != 'personalCenter'">
					<template v-for="(subject, index) in subjects">
						<div
							@click="quickJump(item, subject)"
							:style="'background-color:' + item.background"
							class="img"
							:key="index"
						>
							<span>{{ item.title }}</span>
						</div>
					</template>
				</template>
				<!-- 个人中心 -->
				<div
					@click="$router.push({ name: item.to.name })"
					v-if="item.to.name == 'personalCenter'"
					:style="'background-color:' + item.background"
					class="img"
				>
					<span>{{ item.title }}</span>
				</div>
				<!-- 学生表现 -->
				<div
					@click="$router.push({ name: item.to.name })"
					v-if="item.to.name == 'studentPerformance'"
					:style="'background-color:' + item.background"
					class="img"
				>
					<span>{{ item.title }}</span>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
export default {
	props: {
		items: Array
	},
	computed: {
		subjects() {
			if (this.$store.state.user.userInfo.type == this.$api.account.types.STUDENT.value)
				return this.$store.state.user.userInfo.student.class_grade.subjects || []
			else return []
		}
	},
	methods: {
		quickJump(item, subject) {
			this.$router.push({
				name: item.to.name,
				query: { subject_id: subject.id },
				params: { sbid: subject.id }
			})
		}
	}
}
</script>
<style lang="scss">
.quick-start {
	display: flex;
	justify-content: flex-start;
	margin-bottom: 10px;
	.quick-link,
	.img {
		cursor: pointer;
		display: block;
		margin-right: 7px;
		width: 347px;
		height: 120px;
		border-radius: 8px;
		background: url('../assets/quickenter_background@2x.png');
		background-size: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: all 0.45s cubic-bezier(0.64, 0.09, 0.15, 0.94);

		span {
			color: white;
			font-size: 28px;
			font-weight: bold;
			text-shadow: 0px 2px 0px rgba(0, 0, 0, 0.2);
		}
		&:hover {
			background-position-x: 340px;
		}
	}
}

.section-title {
	margin-bottom: 10px;
	height: 20px;
	line-height: 20px;
	display: flex;
	align-items: center;
	color: #21a74a;

	svg {
		font-size: 20px;
		margin-right: 5px;
	}
}
</style>
